import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Box,
  Text,
  List,
  ListItem,
  Link,
  Textarea,
} from "@chakra-ui/react";
import PrimarySideHeader from "../../../components/PrimarySideHeader";
import PrimaryButton from "../../../components/PrimaryButton";

const ReportsViewModal = ({
  isOpen,
  onClose,
  reports,
  hcfRemarks,
  doctorProvidedOpinion = false,
  handleReportsModalSubmit = () => {},
  downloadFiles = () => {},
}) => {
  const [additionalReports, setAdditionalReports] = useState("");

  const getFileName = (url) => {
    return url.split("/").pop();
  };

  const handleSubmit = () => {
    handleReportsModalSubmit(additionalReports);
    onClose();
  };

  const downloadAllReports = () => {
    let fileType = "patient_reports";
    downloadFiles(fileType);
  };

  const renderRequestedReport = (report) => {
    switch (report.mime_type) {
      case "Text":
        return <Text>{report.opinion}</Text>;
      case "Image":
      case "Audio":
        return (
          <List spacing={2}>
            {report.opinion.split(",").map((fileUrl, idx) => (
              <ListItem key={idx}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Text fontSize="lg">{getFileName(fileUrl)}</Text>
                  <Link
                    href={fileUrl}
                    isExternal
                    color="blue.500"
                    fontWeight="bold"
                    textDecoration="underline"
                  >
                    View
                  </Link>
                </Box>
              </ListItem>
            ))}
          </List>
        );
      default:
        return <Text>{report.opinion}</Text>;
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color="primary.1" textAlign={"center"} fontSize={"2xl"}>
          <Text>Reports</Text>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <PrimaryButton
            mb="20px"
            onClick={downloadAllReports}
            display={"flex"}
            justifyContent={"flex-end"}
            ml="auto"
          >
            Download Reports
          </PrimaryButton>
          {reports?.length > 0 ? (
            <List spacing={3}>
              {reports.map((report, index) => (
                <ListItem key={index}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Text fontSize={"lg"}>{getFileName(report)}</Text>
                    <Link
                      href={report}
                      isExternal
                      color="blue.500"
                      fontWeight="bold"
                      textDecoration="underline"
                    >
                      View
                    </Link>
                  </Box>
                </ListItem>
              ))}
            </List>
          ) : (
            <Text>No reports available.</Text>
          )}

          <PrimarySideHeader mt="20px">Remarks by HCF</PrimarySideHeader>
          <Textarea
            id="remarks"
            name="remarks"
            variant="filled"
            value={hcfRemarks ? hcfRemarks : ""}
            readOnly
          />
          {doctorProvidedOpinion &&
            doctorProvidedOpinion?.add_reports_requested?.length > 0 &&
            doctorProvidedOpinion?.opinion_type === "Need Additional Info" && (
              <>
                <PrimarySideHeader mt="20px">
                  Requested Additional Reports
                </PrimarySideHeader>
                <List spacing={3}>
                  {doctorProvidedOpinion?.add_reports_requested?.map(
                    (report, index) => (
                      <ListItem key={index}>
                        <Box
                          p={3}
                          borderRadius="lg"
                          borderWidth="1px"
                          bg="gray.100"
                        >
                          {renderRequestedReport({
                            ...report,
                            opinion: Array.isArray(report.opinion)
                              ? report.opinion.join(",")
                              : report.opinion,
                          })}
                        </Box>
                      </ListItem>
                    )
                  )}
                </List>
              </>
            )}
          <PrimarySideHeader mt="20px">
            Request Additional Reports
          </PrimarySideHeader>
          <Textarea
            id="remarks"
            name="remarks"
            placeholder="Enter your text here..."
            onChange={(e) => setAdditionalReports(e.target.value)}
          />
          <ModalFooter>
            <PrimaryButton onClick={handleSubmit}>Submit</PrimaryButton>
          </ModalFooter>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ReportsViewModal;
